import React from 'react';

interface CheckboxIconProps {
  checked?: boolean;
}

const CheckboxIcon: React.FC<CheckboxIconProps> = ({ checked = false }) => {
  if (!checked) {
    return (
      <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="0.25" y="0.75" width="13.5" height="13.5" rx="1.75" stroke="#303030" strokeWidth="0.5" />
      </svg>
    );
  }

  return (
    <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect y="0.5" width="14" height="14" rx="2" fill="#ED5C2F" />
      <path
        d="M11.7909 4.97078C11.5124 4.69194 11.0602 4.69212 10.7814 4.97078L6.23808 9.51428L4.21877 7.49498C3.93994 7.21615 3.48796 7.21615 3.20912 7.49498C2.93029 7.77381 2.93029 8.2258 3.20912 8.50463L5.73315 11.0287C5.87248 11.168 6.05518 11.2378 6.23789 11.2378C6.4206 11.2378 6.60347 11.1682 6.7428 11.0287L11.7909 5.98041C12.0697 5.70177 12.0697 5.24959 11.7909 4.97078Z"
        fill="white"
      />
    </svg>
  );
};

export default CheckboxIcon;
